import { assetLoader } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import { screenResizer } from "../ReadinessScreenResizer";
import * as DisplaySettings from "../settings/DisplaySettings";

export default class BootState extends Phaser.State
{
    preload()
    {
        // Load the manifests here that will be required for the PhaserExtension's AssetLoader.
        this.load.json("manifest", "assets/manifest.json");
    }

    create()
    {
        GameModel.sendEvent("Launch", "Grover's Story Circle");
        GameModel.data.gameBootTime = Date.now();

        window.onunload = function() {
            GameModel.sendEvent("Quit Game", GameModel.data.currentStateName);
            GameModel.sendEvent("Quit-Info", "GameCloseButton");
            GameModel.sendEvent("Quit-Info", "GameDuration", Date.now() - GameModel.data.gameBootTime);
            GameModel.sendEvent("Quit-Info", "StoriesCompleted", GameModel.data.storiesPlayed);
            GameModel.sendEvent("Quit-Info", "PDFsDownloaded", GameModel.data.pdfsDownloaded);
        };

        // Parse any manifests with the PhaserExtension's AssetLoader before they're
        // used in other states.
        assetLoader.parseManifest(this.cache.getJSON("manifest"));

        if(window.navigator && (window.navigator.language || window.navigator.userLanguage))
        {
            // make an attempt to start the game on the language the user speaks
            var languageString = window.navigator.language || window.navigator.userLanguage;
            languageString = languageString.substring(0, 2);

            if(languageString == "es")
            {
                GameModel.data.english = false;
            }
            else
            {
                GameModel.data.english = true;
            }
        }

        this.game.width = DisplaySettings.screenWidth;
        this.game.height = DisplaySettings.screenHeight;

        screenResizer.init(
            this.game,
            DisplaySettings.targetScreenWidth,
            DisplaySettings.targetScreenHeight,
            screenResizer.RESIZE_BY_WIDTH
        );

        this.game.stage.backgroundColor = 0xFCBD56;
        this.game.state.start(States.SHARED_LOAD);
    }
}
